import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import useCurrentRegion from 'app/lib/region/useCurrentRegion';
import { getRegions } from 'app/lib/site-configs/selectors';

import RegionItem from '../../../RegionItem/RegionItem';
import ThemeToggleItem from '../../../ThemeToggleItem';

type Props = {
  handleCloseMenu: () => void;
};

const NotAuthorizedUserItems: FC<Props> = ({ handleCloseMenu }) => {
  const currentRegion = useCurrentRegion();
  const regions = useSelector(getRegions);
  const allowRegionItems = regions && regions.length > 1;

  return (
    <>
      {allowRegionItems && regions?.map((region) => (
        <RegionItem key={region.id}
                    region={region}
                    currentRegion={currentRegion}
                    onClose={handleCloseMenu} />
      ))}

      <ThemeToggleItem />
    </>
  );
};

export default NotAuthorizedUserItems;
